import { FC } from 'react';
import { DateRange, DateRangeProps } from 'react-date-range';
import locale from 'date-fns/locale/lt';

type Props = DateRangeProps;

const DateRangePickerBase: FC<Props> = props => (
  <DateRange
    preventSnapRefocus
    locale={locale}
    months={2}
    direction="horizontal"
    dateDisplayFormat="MMMM d, yyyy"
    monthDisplayFormat="LLLL yyyy"
    showDateDisplay={false}
    {...props}
  />
);

export default DateRangePickerBase;
